import '@fontsource/onest/latin-400.css';
import '@fontsource/onest/latin-700.css';
import '@fontsource/onest/latin-800.css';
import "./src/normalize.css";
import "vanilla-cookieconsent/dist/cookieconsent.css";
import "./src/style.scss";
import "./src/cookie-consent.css";
import 'katex/dist/katex.min.css';

// --- import your browser logger ---
import logtail from "./src/utils/logtail-browser";
import { trackPageView } from "./src/utils/analytics-consent";

export const disableCorePrefetching = () => true;

const CHUNK_LOAD_RELOAD_KEY = "gatsby-chunk-load-reload-attempted";

const isChunkLoadError = (reason) => {
  const message = typeof reason === "string" ? reason : reason?.message;

  return (
    reason?.name === "ChunkLoadError" ||
    (typeof message === "string" && /Loading (?:CSS )?chunk \d+ failed/i.test(message))
  );
};

// global error handlers
window.onerror = (message, source, lineno, colno, error) => {
  logtail.error("Global JS error", {
    message,
    source,
    lineno,
    colno,
    url: window.location.href,
    userAgent: navigator.userAgent,
    error: error?.stack || error,
  });
};

window.onunhandledrejection = (event) => {
  const logPromise = logtail.error("Unhandled promise rejection", { reason: event.reason });

  if (!isChunkLoadError(event.reason)) return;

  // Limit automatic recovery to once per tab session to prevent reload loops.
  try {
    if (window.sessionStorage.getItem(CHUNK_LOAD_RELOAD_KEY)) return;
    window.sessionStorage.setItem(CHUNK_LOAD_RELOAD_KEY, "true");
  } catch {
    // Do not reload when the guard cannot be persisted safely.
    return;
  }

  const reloadTimeout = window.setTimeout(() => window.location.reload(), 2000);

  void Promise.resolve(logPromise)
    .catch(() => undefined)
    .then(() => logtail.flush())
    .catch(() => undefined)
    .finally(() => {
      window.clearTimeout(reloadTimeout);
      window.location.reload();
    });
};

export const onRouteUpdate = () => {
  if (process.env.NODE_ENV === "production") trackPageView();
};
